export function attendanceEnabled(meetingSetting: boolean | undefined, roomSetting: boolean | undefined): boolean {
  return (meetingSetting ?? roomSetting) !== false;
}
